import './ClrIconBtn.css';

import React from 'react';

interface Props {
  shape: string;
  disabled?: boolean;
  size?: number;
  title?: string;
  fill?: string;
  solid?: boolean;
  onClick?: (e: React.MouseEvent<HTMLSpanElement>) => void;
}

/**
 * Icon button.
 *  . handle css hover transition.
 *  . handle disabled option.
 */
const ClrIconBtn: React.SFC<Props> = (props: Props) => {
  const {
    disabled,
    title,
    fill = '#191818',
    onClick,
    size = 18,
    shape,
    solid = false
  } = props;
  const classNames =
    'clr-icon-btn ' + (disabled ? 'clr-icon-btn-disabled' : ' ');

  const handleClick = (e: React.MouseEvent<HTMLSpanElement>) => {
    if (!disabled && onClick) {
      onClick(e);
    }
  };

  const iconClass = solid ? 'is-solid' : '';

  return (
    <button
      className={classNames}
      onClick={handleClick}
      title={title}
      aria-label={title}
      disabled={disabled}
    >
      <clr-icon size={size} shape={shape} style={{ fill }} class={iconClass} />
    </button>
  );
};

export default ClrIconBtn;
